import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class OptionsService extends ClientDataService {
  private EKG_IMPORT_FILTER_FROM_TIME_OPTIONS = 'cloudekg_datefilter-custom'
  private PULSARA_DATE_RANGE_OPTIONS = 'tb_date-range-options-custom'
  private EKG_MONITOR_OPTIONS = 'tb_service_monitors'
  private MEDICATIONS_OPTIONS_DOC = 'tb_procedures_meds_data'
  private DOSE_UNITS_OPTIONS_DOC = 'tb_nhtsa_doseunit'
  private ROUTE_OPTIONS_DOC = 'tb_meds_routes'
  private RATE_UNITS_OPTIONS_DOC = 'tb_meds_rateunit'
  private RESPONSE_UNITS_OPTIONS_DOC = 'tb_nhtsa_responseto'
  private AUTHORIZATION_UNITS_OPTIONS_DOC = 'tb_prprocedure_auth'
  private COMPLICATION_OPTIONS_DOC = 'tb_nhtsa_complications-medications'
  private PERFORMED_BY_OPTIONS_DOC = 'serviceusers'
  private PATIENT_ALLERGIES_OPTIONS_DOC = 'tb_pl_allergies'
  private PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS_DOC = 'tb_pl_allergies_medication_button_wall'
  private PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS_DOC = 'tb_pl_allergies_food_environment_button_wall'
  private BASE_OPTIONS_DOC = 'bases'
  private UNIT_OPTIONS_DOC = 'units'
  private EMS_VEHICLE_CALL_UNIT_DOC = 'tb_ems_vehicle_call_unit_custom'
  private EMS_REG_TAIL_NUMBER_DOC = 'tb_ems_registration_tail_custom'
  private STAFFING_LEVEL_OPTIONS_DOC = 'tb_unit_staffing'
  private SHIFT_OPTIONS_DOC = 'tb_prshift'
  private REGISTRATION_TAIL_OPTIONS_DOC = 'tb_unit_tail'
  private DISPATCH_PRIORITY_OPTIONS_DOC = 'tb_prresponse_codes'
  private EMD_OPTIONS_DOC = 'tb_nhtsa_emd'
  private TYPE_OF_SERVICE_OPTIONS_DOC = 'tb_prih'
  private STANDBY_PURPOSE_OPTIONS_DOC = 'tb_nemsis3_standby'
  private CALL_TYPE_OPTIONS_DOC = 'tb_call_type'
  private SCHEDULED_OPTIONS_DOC = 'tb_prsched'
  private PATIENT_CATEGORY_OPTIONS_DOC = 'tb_prcategory-category'
  private DISPATCHED_AS_OPTIONS_DOC = 'tb_prcategory-dispatch'
  private DISPOSITION_OPTIONS_DOC = 'tb_proutcome'
  private UNIT_DISPOSITION_OPTIONS_DOC = 'tb_nemsis3_unit_disposition'
  private PATIENT_EVALUATION_OPTIONS_DOC = 'tb_nemsis3_patient_evaluation'
  private CREW_DISPOSITION_OPTIONS_DOC = 'tb_nemsis3_crew_disposition'
  private TRANSPORT_DISPOSITION_OPTIONS_DOC = 'tb_nemsis3_transport_disposition'
  private RELEASE_REASON_OPTIONS_DOC = 'tb_nemsis3_release_reason'
  private AMBULANCE_TRANSPORT_CODE_OPTIONS_DOC = 'tb_nemsis3_ambtrans_code'
  private MASS_CASUALTY_OPTIONS_DOC = 'tb_nhtsa_masscas'
  private VEHICLE_GRID_OPTIONS_DOC = 'tb_zones'
  private OTHER_TYPE_OPTIONS_SERVICE_DOC = 'tb_prref_common-service'
  private OTHER_TYPE_OPTIONS_DEFAULT_DOC = 'tb_prref_common-default'
  private RESPONSE_MODE_OPTIONS_DOC = 'tb_prmodes_merged-pickup-address'
  private RESPONSE_MODE_CUSTOM_OPTIONS_DOC = 'tb_prdispatch_mode_ref'
  private ACTION_DOC = 'airwayaction_tb_prprocedure_action'
  private VIA_DOC = 'tb_pro2_delivery'
  private AIRWAY_COMPLICATIONS_DOC = 'tb_nemsis3_airway_comp'
  private AIRWAY_VERIFICATION_METHOD = 'tb_pret_verify_v3'
  private CHILDBIRTH_ACTION_DOC = 'childbirth_tb_prprocedure_action'
  private VARIABILITY_DOC = 'tb_fetal_variability'
  private ACCELERATIONS_DOC = 'tb_fetal_acceleration'
  private DECELERATION_DOC = 'tb_fetal_deceleration'
  private UC_STRENGTH_DOC = 'tb_fetal_ucstrength'
  private DTR_DOC = 'tb_fetal_dtr'
  private DEVICES_USED_DOC = 'immob_tb_prprocedure_action'
  private ASSESSMENT_DOC = 'tb_immob_assessment'
  private SITE_DOC = 'tb_immob_site'
  private OPTION_DOC = 'tb_immob_option'
  private IV_SITE_DOC = 'tb_priv_site'
  private TYPE_DOC = 'iv_tb_prprocedure_action'
  private PHYSICIAN_DOC = 'v_command_mds'
  private METHOD_DOC = 'tb_medconsult'
  private TYPES_DOC = 'tb_rescue_types'
  private HYDRAULICS_DOC = 'tb_rescue_hydraulics'
  private TOOLS_DOC = 'tb_rescue_tools'
  private REHAB_DOC = 'tb_rescue_rehabs'
  private ACTIVATIONS_DOC = 'tb_rescue_activations'
  private MODE_DOC = 'tb_prvent_mode'
  private BREATH_TYPE_DOC = 'tb_prvent_breath_type'
  private ACTIONS_VEN_DOC = 'tb_prvent_actions_options_custom'
  private WOUND_CARE_ACTIONS_DOC = 'woundcare_tb_prprocedure_action'
  private WOUND_CARE_SITE_DOC = 'tb_prbody_site'
  private HOSPITAL_NOTIFY_METHOD_DOC = 'tb_hosp_method'
  private HOSPITAL_NOTIFY_ALERT_DOC = 'tb_hosp_alert'
  private POTENTIAL_REGISTRY_DOC = 'tb_nhtsa_regcand'
  private SERVICE_MODULES_DOC = 'servicemodules'
  private HOSPITAL_UNIT_OPTIONS_DOC = 'tb_hosp_unit'
  private HOSPITAL_NAME_OPTIONS_DOC = 'tb_prhospitals'
  private EMS_NAME_OPTIONS_DOC = 'tb_prhems'
  private DESTINATION_HOSPITAL_OPTIONS_DOC = 'tb_prhospitals_destinationaddress'
  private COMMON_ADDRESSES_DOC = 'tb_praddress'
  private DESTINATION_EMS_OPTIONS_DOC = 'tb_prhems_destinationaddress'
  private SCENE_GRID_OPTIONS_DOC = 'tb_zones'
  private MODE_DESCRIPTORS_OPTIONS_DOC = 'tb_nemsis3_responsemode_descr'
  private DESTINATION_MODE_DESCRIPTORS_OPTIONS_DOC = 'tb_nemsis3_transportmode_descr'
  private DESTINATION_TRANSPORT_MODE_OPTIONS_DOC = 'tb_prmodes_merged-destination-address'
  private DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS_DOC = 'tb_prdispatch_mode_rec'
  private CAPABILITIES_OPTIONS_DOC = 'tb_nemsis3_hosp_designate'
  private LOCATION_TYPE_DOC = 'tb_prref_type'
  private INITIAL_PATIENT_ACUITY_OPTIONS_DOC = 'tb_nemsis3_init_pt_acuity'
  private PATIENT_ACTIVITY_OPTIONS_DOC = 'tb_nemsis3_pt_activity'
  private REASON_FOR_ENCOUNTER_OPTIONS_DOC = 'tb_prinj_encounter_reason'
  private DRUGS_AND_ALCOHOL_OPTIONS_DOC = 'tb_prinj_factors'
  private DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS_DOC = 'tb_nhtsa_druguse'
  private ARREST_PRESENT = 'tb_nemsis3_cardiac_arrest'
  private WHO_WITNESSED = 'tb_nemsis3_who_witnessed'
  private ETIOLOGY = 'tb_nhtsa_etiology'
  private THERAPEUTIC_HYPOTHERMIA = 'tb_util_yesno'
  private INITIAL_RHYTHM = 'tb_nhtsa_firstrhy'
  private CPR_PRIOR_EMS_ARRIVAL = 'tb_util_yesno_nemsis3'
  private FIRST_CPR = 'tb_prcpr_by'
  private CPR_BY = 'tb_nemsis3_cpr_by'
  private CPR_TYPE = 'tb_nemsis3_cprtype'
  private RESUSCITATION = 'tb_nhtsa_resuscitation'
  private AED_USE = 'tb_nemsis3_aeduse'
  private FIRST_AED_BY = 'tb_nemsis3_firstaed'
  private AED_BY = 'tb_nemsis3_aeduse_who'
  private DEFIB_TYPE = 'tb_cardiac_defib_type_custom'
  private DEFIB_BY = 'tb_prca_defibby'
  private DISC_REASON = 'tb_nhtsa_discreason'
  private RETURN_CIRCULATION = 'tb_nemsis3_cardiac_retcirc'
  private DEST_RHYTHM = 'tb_nhtsa_cardrhy'
  private ARREST_RESULT = 'tb_nemsis3_cardiac_end_event'
  private INTENTIONAL_OPTIONS_DOC = 'tb_prinj_intent'
  private TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS_DOC = 'tb_nemsis3_traumacriteria'
  private TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS_DOC = 'v_prmvi_impact'
  private INJURY_CAUSE_OPTIONS_DOC = 'v_nemsis3_injury_cause'
  private MECHANISM_OPTIONS_DOC = 'v_prinj_mech'
  private SAFETY_EQUIPMENT_OPTIONS_DOC = 'v_prmvi_safety'
  private FALL_SURFACE_OPTIONS_DOC = 'tb_prinj_surface'
  private LANDED_ON_OPTIONS_DOC = 'tb_prinj_bodyloc'
  private WORK_RELATED_OPTIONS_DOC = 'tb_nhtsa_workrel'
  private CC_DURATION_UNITS_OPTIONS_DOC = 'tb_nhtsa_ccdurunits'
  private SC_DURATION_UNITS_OPTIONS_DOC = 'tb_nhtsa_secdurunits'
  private OC_DURATION_UNITS_OPTIONS_DOC = 'tb_nemsis3_complaint_dur_unit'
  private AIRWAY_TEMPERTURE_DOC = 'tb_airway-temp-custom'
  private MEDICATIONS_COMMON_DOC = 'tb_medication-common-custom'
  private SECTIONS_OPTIONS_DOC = 'tb_sections-options-custom'
  private DESTINATION_BASIS_OPTIONS_DOC = 'tb_prdestbasis'
  private TIME_ZONES_DOC = 'tb_timezones'
  private INSURANCE_PRIORITY_DOC = 'tb_bill_payor_priority'
  private RELATIONSHIP_DOC = 'tb_pt_relatives'
  private NPP_FORM_OPTIONS_DOC = 'tb_prnpp'
  private CONSENT_FORM_SIGNED_OPTION_DOC = 'tb_util_yesnona'
  private MEDICAL_NECESSITY_SIGNED_OPTIONS_DOC = 'tb_util_yesnona'
  private PCS_REASON_OPTIONS_DOC = 'tb_nemsis3_pcs_reason'
  private PCS_PROVIDER_TYPE_DOC = 'tb_pcs_provider_type'
  private INTERFACILITY_TRANSFER_DOCS = 'tb_nemsis3_reason_ift'
  private CMS_CONDITION_CODE = 'tb_nhtsa_conditioncodes'
  private CONDITION_CODE_MODIFIER = 'tb_nhtsa_condition_modifier'
  private CMS_TRANSPORT_REASON = 'tb_nemsis3_ambtrans_reason'
  private AMBULANCE_CONDITION_INDICATION = 'tb_nemsis3_amb_condition_ind'
  private PRIMARY_PAYMENT_METHOD_TYPE = 'tb_nhtsa_billtypes'
  private X12_PAYER_TYPE = 'tb_nemsis3_payment_payer_type'
  private GUARANTORS_AGE_DOCS = 'tb_relationshipsandguarantors-patientageunit-custom'
  private CAMERA_ATTACHMENTS_CATEGORY_OPTIONS_DOC = 'tb_prblob_cat'
  // Medical/Surgical History Layout > Basic
  private MEDICAL_HISTORY_BASIC_FULL_LIST = 'medical_history_basic_full_list'
  private MEDICAL_HISTORY_BASIC_BUTTON_WALL = 'medical_history_basic_button_wall'
  // Medical/Surgical History Layout > ICD/NEMSIS Basic
  private MEDICAL_HISTORY_ICD_NEMSIS_BASIC_FULL_LIST = 'medical_history_icd_nemsis_basic_full_list'
  private MEDICAL_HISTORY_ICD_NEMSIS_BASIC_BUTTON_WALL = 'medical_history_icd_nemsis_basic_button_wall'
  // Medical/Surgical History Layout > ICD/NEMSIS Standard (Future Use - Don't remove)
  private MEDICAL_HISTORY_ICD_NEMSIS_STANDARD_FULL_LIST = 'medical_history_icd_nemsis_standard_full_list'
  private MEDICAL_HISTORY_ICD_NEMSIS_STANDARD_BUTTON_WALL = 'medical_history_icd_nemsis_standard_button_wall'
  private OBTAINED_FROM_OPTIONS = 'tb_pmhx_from'
  private EMERGENCY_INFO_FORM_OPTIONS = 'tb_emergency-info-custom'
  private DISPATCH_FACTORS_OPTIONS = 'tb_nhtsa_dispdelay'
  private RESPONSE_FACTORS_OPTIONS = 'tb_prcare_factors_response'
  private SCENE_FACTORS_OPTIONS = 'tb_prcare_factors_scene'
  private TRANSPORT_FACTORS_OPTIONS = 'tb_prcare_factors_transport'
  private TURN_AROUND_FACTORS_OPTIONS = 'tb_nhtsa_tadelay'
  private FACTORS_OPTIONS = 'tb_prcare_factors'
  private PACING_MODE_OPTIONS = 'tb_cardiac_pace_mode'
  private COMPRESSION_RATE_OPTIONS = 'tb_cardiac_mechcpr_rate'
  private LOCATION_OPTIONS = 'tb_cardiac_defib_pad_loc'
  private MECHANICAL_CPR_TYPE_OPTIONS = 'tb_prmechanical_cpr'
  private DISASTER_DOC = 'tb_nhtsa_disaster'
  private PR_PT_MOVED_VIA_DOC = 'tb_nhtsa_movedvia'
  private PR_PT_POSITION_DOC = 'tb_nhtsa_ptposition'
  private PR_OTHER_AGENCIES_DOC = 'tb_nhtsa_othersvc'
  private TRANSFER_OF_CARE_OPTIONS = 'tb_nemsis3_transfer_of_care'
  private FIRST_ON_SCENE_DOC = 'tb_util_yesno_nemsis3'
  private LEVEL_CARE_PER_PROTOCOL_OPTIONS = 'tb_nemsis3_level_of_care_per_protocol'
  private PR_PT_MOVED_FROM_DOC = 'tb_nhtsa_movedfrom'
  private PR_TRANSPORT_ASSESS_DOC = 'tb_nemsis3_transport_assess'
  private PR_DISPO_INSTRUCTIONS_DOC = 'tb_nemsis3_dispinstruct'
  private AIRWAY_STATUS_OPTIONS = 'tb_prairway_status'
  private AIRWAY_TYPE_OPTIONS = 'tb_prairway_secured'
  private AIRWAY_BY_OPTIONS = 'tb_nhtsa_aidby'
  private AIRWAY_OUTCOME_OPTIONS = 'tb_nhtsa_aidoutcome'
  private AIRWAY_VERIFICATION_ASSESS_OPTIONS = 'tb_pret_verify_v3'
  private AIRWAY_ASSESS_OPTIONS = 'tb_prairway_assess'
  private AIRWAY_BROSELOW_OPTIONS = 'tb_prbroselow'
  private BREATH_SOUND_LEFT = 'tb_prbreath_sounds'
  private BREATH_SOUND_RIGHT = 'tb_prbreath_sounds'
  private RESP_EFFORT = 'tb_prresp_effort'
  private RESP_VIA = 'tb_pro2_delivery'
  private RESP_PERFORM_BY = 'tb_nhtsa_aidby'
  private RESP_OUTCOME = 'tb_nhtsa_aidoutcome'
  private RESP_EXAM = 'tb_prresp_assess'
  private PN_MEDICATION_MEDICATION_OPTIONS = 'tb_procedures_meds_data'
  private EXPOSURE_EQUIPMENT_OPTIONS = 'tb_nhtsa_equipment'
  private SUSPECTED_EXPOSURE_TYPE_OPTIONS = 'tb_nhtsa_fluidexp'
  private EXPOSED_TO_OPTIONS = 'tb_prexposure_to'
  private EXPOSURE_CREW = 'tb_exposure_crew'
  private SUSPECTED_EXPSOURE = 'tb_suspected_exposure'
  private AIRBAG_DEPLOYED_OPTIONS = 'tb_prmvi_airbag'
  private VEHICLE_IMPACT_SITE_OPTIONS = 'tb_vehicle-impact-site-custom'
  private LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS = 'tb_nemsis3_pt_loc_in_vehicle'
  private EXTRICATION_REQUIRED_OPTIONS = 'tb_extrication-required-custom'
  private COUNTY_DOC = 'tb_county'
  private WAS_PATIENT_IMMOBILIZED_PERFORMED_BY = 'tb_nhtsa_aidby'
  private WAS_PATIENT_IMMOBILIZED_OUTCOME = 'tb_nhtsa_aidoutcome'
  private PTS_SIZE = 'tb_prpts_size'
  private PTS_AIRWAY = 'tb_prpts_air'
  private PTS_BP = 'tb_prpts_bp'
  private PTS_CN = 'tb_prpts_cns'
  private PTS_SKEL = 'tb_prpts_skel'
  private PTS_WOUND = 'tb_prpts_wound'
  private EYE_OPENING_RESPONSE_DOCS = 'tb_prgcs_adult_v2-eye'
  private VERBAL_RESPONSE_DOCS = 'tb_prgcs_adult_v2-verbal'
  private MOTOR_RESPONSE_DOCS = 'tb_prgcs_adult_v2-motor'
  private GCS_QUALIFIER = 'tb_nhtsa_gcsqual'
  private MOTOR_OPTIONS_DOC = 'tb_prneuro_motor'
  private SENSORY_OPTIONS_DOC = 'tb_prneuro_sensory'
  private PUPILS_SIZE_OPTIONS_DOC = 'tb_prpupil_size'
  private PUPILS_REACT_OPTIONS_DOC = 'tb_prpupil_rx'
  private HEAD_CONCIOUSNESS_OPTIONS_DOC = 'tb_prneuro_loc'
  private THROM_SCREEN_OPTIONS_DOC = 'tb_nhtsa_thromscreen'
  private STROKE_SCALE_OPTIONS_DOC = 'tb_stroke_scale'
  private STROKE_SCALE_SCORE_OPTIONS_DOC = 'tb_stroke_scale_score'
  private STROKE_SCALE_CONFIG_OPTIONS_DOC = 'tb_stroke_scale_config'
  private STROKE_CVA_SYMPTOMS_RESOLVED_OPTIONS_DOC = 'tb_nemsis3_stroke_cva_symptoms'
  private HEAD_LOSS_CONS_OPTIONS_DOC = 'tb_state'
  private PULSES_OPTIONS_DOC = 'tb_prcv_pulses'
  private CARDIO_ASSESS_OPTIONS = 'tb_prcv_assess'
  private CARDIO_TEMP_METHODS_OPTIONS = 'tb_temp_method'
  private CARDIO_JVD_OPTIONS = 'tb_prcv_jvd'
  private CARDIO_CAP_REFILL_OPTIONS = 'tb_prcv_caprefill'
  private CARDIO_EDEMA_OPTIONS = 'tb_prcv_edema'
  private CARDIO_ART_OPTIONS = 'tb_prart_line'
  private CARDIO_SWAN_OPTIONS = 'tb_prswan_line'
  private CARDIO_PACEMAKER_TYPE_OPTIONS = 'tb_prcv_pacemaker'
  private JC_TIMEOUT_DOC = 'tb_jc_timeout'
  private REASONS_FOR_FAILURE_DOC = 'tb_nemsis3_airway_fail'

  private SYSTEM_DOC = 'v_prinj_system'
  private SYMPTOMS_DOC = 'v_prinj_symptom'
  private IMPRESSIONS_DOC = 'v_primpression'
  private ANATOMIC_LOCATION_DOC = 'tb_prinj_location'
  private CONDITION_AT_DEST_DOC = 'tb_nhtsa_ptcondition'
  private FINAL_PATIENT_ACUITY_DOC = 'tb_nemsis3_final_acuity'
  private IS_PATIENT_PREGNANT_OPTIONS = 'tb_pregnant'
  private SELECTION_RANGE_OPTIONS = 'tb_selection-ranges-custom'
  private BLOODY_SHOW_OPTIONS = 'tb_bloody-show-custom'
  private PRENATAL_CARE_OPTIONS = 'tb_prenatal_care'
  private MEMBRANES_AMNIOTIC_FLUID_OPTIONS = 'tb_neo_membranes'
  private MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS = 'tb_neo_tocolytics'
  private BURN_TYPE_OPTIONS = 'tb_burn-type-custom'

  private ASSESSMENT_EXAM_OPTIONS = 'tb_get_exam_values'
  private ASSESSMENT_MENTAL_OPTIONS = 'tb_v_prmental_assess_p3'
  private ASSESSMENT_NEURO_OPTIONS = 'tb_v_prneuro_assess_p3'
  private ASSESSMENT_DEFAULT_OPTIONS = 'tb_pr_defaults_exam'
  private ALS_ASSESSMENT_OPTIONS = 'tb_prals_assessment'

  private NEURO_OPTIONS = 'tb_neuro_options'
  private ACTION_OPTIONS = 'tb_proc_assess_config'
  private SEPSIS_INDICATORS = 'tb_sepsis_indicators'
  private CUSTOM_ACTION_FIELDS = 'tb_proc_assess_fields'
  private CUSTOM_ACTION_FIELDS_ANSWERS = 'tb_proc_assess_answers'

  //PN-NV options document
  private ALL_PNNV_OPTIONS = 'tb_pnnv-options-custom'

  private OTHER_AGENCY_NAME_OPTIONS = 'other_agencies'
  private OTHER_AGENCY_TYPE_OPTIONS = 'tb_nemsis3_other_svc_scene'

  public STATE_RULES = 'validation_nemsis_'
  public SERVICE_RULES = 'validation_service'
  private STATE_CUSTOM_ELEMENTS_DOC = 'tb_nemsis3_custom_config'
  private STATE_CUSTOM_ELEMENT_CONFIG_GROUPS = 'tb_nemsis3_custom_config_groups'
  private COMPLEX_RULES_COUNT = 'tb_required_rules_count'
  private SECURITY_QUESTION_ANSWER_OPTIONS = 'tb_user_security_questions'
  private SERVICES_BILLING = 'services_billing'

  private CLINICAL_INDICATOR_OPTIONS = 'tb_bloodadmin_indicators'
  private TRANSFUSION_CONSENT_OPTIONS = 'tb_transfusion_consent-custom'
  private BLOOD_PRODUCT_OPTIONS = 'tb_bloodadmin_products'
  private BLOOD_PRODUCT_ROUTE_OPTIONS = 'v_blood_product_route'
  private IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS = 'tb_bloodadmin_explain'
  private VAD_TYPE = 'tb_vad_type'
  private VAD_ALARMS = 'v_primpellaalarms'
  private VAD_SITE_ASSESSMENT = 'v_primpellaassessment'
  private VAD_CATHETER_SIZE = 'v_primpellacathsize'
  private VAD_PLACEMENT_CONFIRMED_BY = 'v_primpellaconfirmed'
  private VAD_INSERT_LOCATION = 'v_primpellainsertion'
  private VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS = 'v_primpellamotor'
  private VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS = 'v_primpellaplacement'
  private VAD_PLACEMENT_LOCATION = 'v_primpellaplaceloc'
  private VAD_POWER_TYPE = 'v_primpellapowertype'
  private VAD_BACKUP_OPTIONS = 'v_prvadbackupoptions'
  private VAD_BATTERY_STATUS = 'v_prvadbatterystatus'
  private VAD_FLOW_TYPE = 'v_prvadflowtype'
  private VAD_INDICATION = 'v_prvadindication'
  private VAD_MAKE_MODEL = 'v_prvadmakemodel'
  private VAD_MAKE_MODEL_IMPELLA = 'v_prvadmakemodimp'
  private TB_UTIL_YES_NO = 'tb_util_yesno'
  private TEAM_OPTIONS_DOC = 'tb_prteams'
  private TEAM_CARE_ONLY_OPTIONS_DOC = 'tb_util_yesno'
  private EQUIPMENT_OPTIONS_DOC = 'tb_prspec_equip'
  private PROVIDER_ROLES_OPTIONS_DOC = 'v_nemsis3_spec_care_provider'
  private SCT_PROCS_OPTIONS_DOC = 'tb_sct_procs'
  private SCT_MEDS_OPTIONS_DOC = 'tb_sct_meds'
  private CUSTOM_FLUIDS_OPTIONS_DOC = 'tb_fluids'

  private CRITICAL_CARE_SITE_OPTIONS_DOC = 'tb_crit_care_site'
  private IABP_AUGMENTATION_OPTIONS_DOC = 'tb_iabp_augmentation_series'
  private TASK_OPTIONS_DOC = 'tb_iabp_tasks'
  private IABP_FREQUENCY_OPTIONS_DOC = 'tb_priabp_freq_critical_care'
  private INSERTION_SITE_OPTIONS_DOC = 'tb_priabp_ins'
  private TRIGGER_UTILIZED_OPTIONS_DOC = 'tb_priabp_trigger_critical_care'
  private CRITICAL_CARE_ACTION_OPTIONS_DOC = 'tb_prprocedure_critical_care_action'
  private SLOW_GAS_LEAK_OPTIONS_DOC = 'tb_priabp_gasleak'
  private AUTO_MANUAL_OPTIONS_DOC = 'tb_priabp_automanual'
  private ADMINISTERED_BY_OTHER_UNIT_OPTIONS_DOC = 'tb_util_yesno_nemsis3'
  private AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS_DOC = 'tb_nemsis3_airway_placement_technique'

  private SPECIAL_REPORT_DATA_DOC = 'specialreportsformquestions-custom'
  private SPECIAL_REPORT_CATEGORIES_DOC = 'specialreportscategories-custom'
  private SPECIAL_REPORT_SUB_CATEGORIES_DOC = 'specialreportssubcategories-custom'
  private MEDICAL_CONSULT_FACILITY_OPTIONS_DOC = 'tb_prcmdfac'
  private FLIGHT_PLAN_OPTIONS_DOC = 'tb_flight_plan-custom'

  async getPnMedicationMedicationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PN_MEDICATION_MEDICATION_OPTIONS)
  }

  async getBreathSoundLeftOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BREATH_SOUND_LEFT)
  }

  async getBreathSoundRightOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BREATH_SOUND_RIGHT)
  }

  async getRespEffortOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_EFFORT)
  }

  async getRespViaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_VIA)
  }

  async getRespPerformByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_PERFORM_BY)
  }

  async getRespOutcomeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_OUTCOME)
  }

  async getRespExamOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESP_EXAM)
  }

  async getMotorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MOTOR_OPTIONS_DOC)
  }

  async getSensoryOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SENSORY_OPTIONS_DOC)
  }

  async getPupilsSizeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PUPILS_SIZE_OPTIONS_DOC)
  }

  async getPupilsReactOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PUPILS_REACT_OPTIONS_DOC)
  }

  async getHeadConciousnessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HEAD_CONCIOUSNESS_OPTIONS_DOC)
  }

  async getThromScreenOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.THROM_SCREEN_OPTIONS_DOC)
  }

  async getStrokeScaleOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_SCALE_OPTIONS_DOC)
  }

  async getStrokeScaleScoreOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_SCALE_SCORE_OPTIONS_DOC)
  }

  async getStrokeScaleConfigOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_SCALE_CONFIG_OPTIONS_DOC)
  }

  async getStrokeCvaSymptomsResolvedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STROKE_CVA_SYMPTOMS_RESOLVED_OPTIONS_DOC)
  }

  async getHeadLossConsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HEAD_LOSS_CONS_OPTIONS_DOC)
  }

  async getPulsesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PULSES_OPTIONS_DOC)
  }

  async getPerformedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PERFORMED_BY_OPTIONS_DOC)
  }

  async getDoseUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DOSE_UNITS_OPTIONS_DOC)
  }

  async getRateUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RATE_UNITS_OPTIONS_DOC)
  }

  async getRouteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ROUTE_OPTIONS_DOC)
  }

  async getResponseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESPONSE_UNITS_OPTIONS_DOC)
  }

  async getAuthorizationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AUTHORIZATION_UNITS_OPTIONS_DOC)
  }

  async getComplicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMPLICATION_OPTIONS_DOC)
  }

  async getAirwayTempertureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_TEMPERTURE_DOC)
  }

  async getVentilatorTempertureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_TEMPERTURE_DOC)
  }

  async getMedicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICATIONS_OPTIONS_DOC)
  }

  async getPatientAllergiesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_ALLERGIES_OPTIONS_DOC)
  }

  async getPatientAllergiesMedicationButtonWallOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_ALLERGIES_MEDICATION_BUTTON_WALL_OPTIONS_DOC)
  }

  async getPatientAllergiesFoodEnvironmentButtonWallOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_ALLERGIES_FOOD_ENVIRONMENT_BUTTON_WALL_OPTIONS_DOC)
  }

  async getBaseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BASE_OPTIONS_DOC)
  }

  async getUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.UNIT_OPTIONS_DOC)
  }

  async getEMSVehicleCallUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMS_VEHICLE_CALL_UNIT_DOC)
  }
  async getEMSRegTailNumberOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMS_REG_TAIL_NUMBER_DOC)
  }

  async getStaffingLevelOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STAFFING_LEVEL_OPTIONS_DOC)
  }

  async getShiftOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SHIFT_OPTIONS_DOC)
  }

  async getRegistrationTailOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REGISTRATION_TAIL_OPTIONS_DOC)
  }

  async getDispatchPriorityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISPATCH_PRIORITY_OPTIONS_DOC)
  }

  async getEmdPerformedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMD_OPTIONS_DOC)
  }

  async getTypeOfServiceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TYPE_OF_SERVICE_OPTIONS_DOC)
  }

  async getStandbyPurposeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STANDBY_PURPOSE_OPTIONS_DOC)
  }

  async getCallTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CALL_TYPE_OPTIONS_DOC)
  }

  async getScheduledOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SCHEDULED_OPTIONS_DOC)
  }

  async getPatientCategoryOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_CATEGORY_OPTIONS_DOC)
  }

  async getDispatchedAsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISPATCHED_AS_OPTIONS_DOC)
  }

  async getDispositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISPOSITION_OPTIONS_DOC)
  }

  async getUnitDispositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.UNIT_DISPOSITION_OPTIONS_DOC)
  }

  async getPatientEvaluationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_EVALUATION_OPTIONS_DOC)
  }

  async getCrewDispositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CREW_DISPOSITION_OPTIONS_DOC)
  }

  async getTransportDispositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRANSPORT_DISPOSITION_OPTIONS_DOC)
  }

  async getRefusalReleaseReasonDispositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RELEASE_REASON_OPTIONS_DOC)
  }

  async getAmbulanceTransportCodeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AMBULANCE_TRANSPORT_CODE_OPTIONS_DOC)
  }

  async getMassCasualtyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MASS_CASUALTY_OPTIONS_DOC)
  }

  async getVehicleGridOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VEHICLE_GRID_OPTIONS_DOC)
  }

  async getOtherTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    const servicesDocument = await this.getDocument(this.OTHER_TYPE_OPTIONS_SERVICE_DOC)

    if (servicesDocument && servicesDocument.entity?.length) {
      return servicesDocument
    }

    return await this.getDocument(this.OTHER_TYPE_OPTIONS_DEFAULT_DOC)
  }

  async getResponseModeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESPONSE_MODE_OPTIONS_DOC)
  }

  async getResponseModeCustomOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESPONSE_MODE_CUSTOM_OPTIONS_DOC)
  }

  async getActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTION_DOC)
  }

  async getViaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VIA_DOC)
  }

  async getAirwayComplicationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_COMPLICATIONS_DOC)
  }

  async getAirwayVerificationMethodOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_VERIFICATION_METHOD)
  }

  async getChildbirthActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CHILDBIRTH_ACTION_DOC)
  }

  async getVariabilityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VARIABILITY_DOC)
  }

  async getAccelerationsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACCELERATIONS_DOC)
  }

  async getDecelerationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DECELERATION_DOC)
  }

  async getUcStrengthOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.UC_STRENGTH_DOC)
  }

  async getDtrOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DTR_DOC)
  }

  async getDevicesUsedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DEVICES_USED_DOC)
  }

  async getAssessmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ASSESSMENT_DOC)
  }

  async getSiteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SITE_DOC)
  }

  async getOptionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OPTION_DOC)
  }

  async getIVSiteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IV_SITE_DOC)
  }

  async getTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TYPE_DOC)
  }

  async getPhysicianOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PHYSICIAN_DOC)
  }

  async getMethodOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.METHOD_DOC)
  }

  async getTypes(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TYPES_DOC)
  }

  async getHydraulics(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HYDRAULICS_DOC)
  }

  async getTools(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TOOLS_DOC)
  }

  async getRehab(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REHAB_DOC)
  }

  async getActivations(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTIVATIONS_DOC)
  }

  async getMode(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MODE_DOC)
  }

  async getBreathType(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BREATH_TYPE_DOC)
  }

  async getActionsVentilatorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTIONS_VEN_DOC)
  }

  async getWoundCareActions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WOUND_CARE_ACTIONS_DOC)
  }

  async getWoundCareSite(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WOUND_CARE_SITE_DOC)
  }

  async getHospitalNotifyMethod(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HOSPITAL_NOTIFY_METHOD_DOC)
  }

  async getHospitalNotifyAlert(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HOSPITAL_NOTIFY_ALERT_DOC)
  }

  async getPotentialRegistry(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.POTENTIAL_REGISTRY_DOC)
  }

  async getServiceModules(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SERVICE_MODULES_DOC)
  }

  async getHospitalUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HOSPITAL_UNIT_OPTIONS_DOC)
  }

  async getHospitalNameOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HOSPITAL_NAME_OPTIONS_DOC)
  }

  async getEMSNameOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMS_NAME_OPTIONS_DOC)
  }

  async getDestinationHospitalOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_HOSPITAL_OPTIONS_DOC)
  }

  async getDestinationEMSOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_EMS_OPTIONS_DOC)
  }

  async getSceneGridOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SCENE_GRID_OPTIONS_DOC)
  }

  async getModeDescriptorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MODE_DESCRIPTORS_OPTIONS_DOC)
  }

  async getDestinationModeDescriptorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_MODE_DESCRIPTORS_OPTIONS_DOC)
  }

  async getDestinationTransportModeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_TRANSPORT_MODE_OPTIONS_DOC)
  }

  async getDestinationTransportModeCustomOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_TRANSPORT_MODE_CUSTOM_OPTIONS_DOC)
  }

  async getCapabilitiesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CAPABILITIES_OPTIONS_DOC)
  }

  async getLocationTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LOCATION_TYPE_DOC)
  }

  async getInitialPatientAcuityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INITIAL_PATIENT_ACUITY_OPTIONS_DOC)
  }
  async getPatientActivityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PATIENT_ACTIVITY_OPTIONS_DOC)
  }
  async getReasonForEncounterOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REASON_FOR_ENCOUNTER_OPTIONS_DOC)
  }
  async getDrugsAndAlcoholOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DRUGS_AND_ALCOHOL_OPTIONS_DOC)
  }

  async getDrugsAndAlcoholIndicatorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DRUGS_AND_ALCOHOL_INDICATORS_OPTIONS_DOC)
  }
  async getArrestPresentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ARREST_PRESENT)
  }
  async getWhoWitnessedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WHO_WITNESSED)
  }
  async getEtiologyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ETIOLOGY)
  }
  async getTherapeuticHypothermiaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.THERAPEUTIC_HYPOTHERMIA)
  }
  async getInitialRhythmOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INITIAL_RHYTHM)
  }
  async getCprPriorEmsArrivalOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CPR_PRIOR_EMS_ARRIVAL)
  }
  async getFirstCprOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FIRST_CPR)
  }
  async getCprByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CPR_BY)
  }
  async getCprTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CPR_TYPE)
  }
  async getResuscitationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESUSCITATION)
  }
  async getAedUseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AED_USE)
  }
  async getFirstAedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FIRST_AED_BY)
  }
  async getAedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AED_BY)
  }
  async getDefibTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DEFIB_TYPE)
  }
  async getDefibByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DEFIB_BY)
  }
  async getDiscReasonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISC_REASON)
  }
  async getReturnCirculationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RETURN_CIRCULATION)
  }
  async getDestRhythmOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DEST_RHYTHM)
  }
  async getArrestResultOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ARREST_RESULT)
  }

  async getIntentionalOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INTENTIONAL_OPTIONS_DOC)
  }

  async getTraumatriageCriteriaHighRiskOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRAUMA_TRIAGE_CRITERIA_HIGH_RISK_OPTIONS_DOC)
  }

  async getTraumaTriageCriteriaModerateRiskOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRAUMA_TRIAGE_CRITERIA_MODERATE_RISK_OPTIONS_DOC)
  }

  async getInjurycauseOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INJURY_CAUSE_OPTIONS_DOC)
  }

  async getMechanismOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MECHANISM_OPTIONS_DOC)
  }

  async getSafetyEquipmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SAFETY_EQUIPMENT_OPTIONS_DOC)
  }

  async getFallsurfaceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FALL_SURFACE_OPTIONS_DOC)
  }

  async getLandedonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LANDED_ON_OPTIONS_DOC)
  }

  async getWorkrelatedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WORK_RELATED_OPTIONS_DOC)
  }

  async getCCDurationUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CC_DURATION_UNITS_OPTIONS_DOC)
  }

  async getSCDurationUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SC_DURATION_UNITS_OPTIONS_DOC)
  }

  async getOCDurationUnitsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OC_DURATION_UNITS_OPTIONS_DOC)
  }

  async getMedicalHistoryBasicFullListOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_HISTORY_BASIC_FULL_LIST)
  }

  async getMedicalHistoryBasicButtonWallOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_HISTORY_BASIC_BUTTON_WALL)
  }

  async getMedicalHistoryIcdNemsisBasicFullListOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_HISTORY_ICD_NEMSIS_BASIC_FULL_LIST)
  }

  async getMedicalHistoryIcdNemsisBasicButtonWallOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_HISTORY_ICD_NEMSIS_BASIC_BUTTON_WALL)
  }

  async getObtainedFromOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OBTAINED_FROM_OPTIONS)
  }

  async getEmergencyInfoFormOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMERGENCY_INFO_FORM_OPTIONS)
  }

  async getMedicationCommonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICATIONS_COMMON_DOC)
  }

  async getSectionsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SECTIONS_OPTIONS_DOC)
  }

  async getDestinationBasisOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DESTINATION_BASIS_OPTIONS_DOC)
  }

  async getTimeZoneOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TIME_ZONES_DOC)
  }

  async getInsurancePriorityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INSURANCE_PRIORITY_DOC)
  }
  async getRelationshipOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RELATIONSHIP_DOC)
  }
  async getConsentFormSignedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CONSENT_FORM_SIGNED_OPTION_DOC)
  }

  async getNppFormOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.NPP_FORM_OPTIONS_DOC)
  }

  async getMedicalNecessitySignedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_NECESSITY_SIGNED_OPTIONS_DOC)
  }

  async getPcsReasonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PCS_REASON_OPTIONS_DOC)
  }

  async getPcsProviderTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PCS_PROVIDER_TYPE_DOC)
  }

  async getInterfacilityTransferOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INTERFACILITY_TRANSFER_DOCS)
  }

  async getCmsConditionCodeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CMS_CONDITION_CODE)
  }

  async getConditionCodeModifierOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CONDITION_CODE_MODIFIER)
  }

  async getCmsTransportReasonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CMS_TRANSPORT_REASON)
  }

  async getAmbulanceConditionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AMBULANCE_CONDITION_INDICATION)
  }

  async getPrimaryPaymentMethodOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PRIMARY_PAYMENT_METHOD_TYPE)
  }

  async getX12PayerTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.X12_PAYER_TYPE)
  }

  async getGuarantorsAgeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.GUARANTORS_AGE_DOCS)
  }

  async getCameraAttachmentsCategoryOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CAMERA_ATTACHMENTS_CATEGORY_OPTIONS_DOC)
  }

  async getDispatchFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISPATCH_FACTORS_OPTIONS)
  }

  async getResponseFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESPONSE_FACTORS_OPTIONS)
  }

  async getSceneFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SCENE_FACTORS_OPTIONS)
  }

  async getTransportFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRANSPORT_FACTORS_OPTIONS)
  }

  async getTurnAroundFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TURN_AROUND_FACTORS_OPTIONS)
  }

  async getFactorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FACTORS_OPTIONS)
  }

  async getPacingModeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PACING_MODE_OPTIONS)
  }

  async getCompressionRateOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMPRESSION_RATE_OPTIONS)
  }

  async getLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LOCATION_OPTIONS)
  }

  async getMechanicalCprTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MECHANICAL_CPR_TYPE_OPTIONS)
  }

  async getPrDisasterOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DISASTER_DOC)
  }

  async getFirstOnSceneOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FIRST_ON_SCENE_DOC)
  }

  async getLevelCarePerProtocolOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LEVEL_CARE_PER_PROTOCOL_OPTIONS)
  }

  async getPrOtherAgenciesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_OTHER_AGENCIES_DOC)
  }

  async getTransferOfCareOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRANSFER_OF_CARE_OPTIONS)
  }

  async getPrPtMovedViaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_PT_MOVED_VIA_DOC)
  }

  async getPrPtPositionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_PT_POSITION_DOC)
  }

  async getPrPtMovedFromOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_PT_MOVED_FROM_DOC)
  }

  async getPrTransportAssessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_TRANSPORT_ASSESS_DOC)
  }

  async getPrDispoInstructionsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PR_DISPO_INSTRUCTIONS_DOC)
  }

  async getAirwayStatusOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_STATUS_OPTIONS)
  }

  async getAirwayTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_TYPE_OPTIONS)
  }

  async getAirwayByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_BY_OPTIONS)
  }

  async getAirwayOutcomeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_OUTCOME_OPTIONS)
  }

  async getAirwayVerificationAssessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_VERIFICATION_ASSESS_OPTIONS)
  }

  async getAirwayAssessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_ASSESS_OPTIONS)
  }

  async getAirwayBroselowOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_BROSELOW_OPTIONS)
  }

  async getPtsSizeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_SIZE)
  }

  async getPtsAirwayOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_AIRWAY)
  }

  async getPtsBpOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_BP)
  }

  async getPtsCnsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_CN)
  }

  async getPtsSkelOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_SKEL)
  }

  async getPtsWoundOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PTS_WOUND)
  }

  async getWasPatientImmobilizedPerformedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WAS_PATIENT_IMMOBILIZED_PERFORMED_BY)
  }

  async getWasPatientImmobilizedOutcomeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WAS_PATIENT_IMMOBILIZED_OUTCOME)
  }

  async getGCSQualifierOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.GCS_QUALIFIER)
  }

  async getEyeOpeningResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EYE_OPENING_RESPONSE_DOCS)
  }

  async getVerbalResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VERBAL_RESPONSE_DOCS)
  }

  async getMotorResponse(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MOTOR_RESPONSE_DOCS)
  }
  async getCardioAssessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_ASSESS_OPTIONS)
  }

  async getCardioTempMethodOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_TEMP_METHODS_OPTIONS)
  }

  async getCardioJVDOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_JVD_OPTIONS)
  }

  async getCardioCapRefillOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_CAP_REFILL_OPTIONS)
  }

  async getCardioEdemaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_EDEMA_OPTIONS)
  }

  async getCardioArtOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_ART_OPTIONS)
  }

  async getCardioSwanOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_SWAN_OPTIONS)
  }

  async getCardioPacemakerTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CARDIO_PACEMAKER_TYPE_OPTIONS)
  }

  async getJointCommissionTimeOutOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.JC_TIMEOUT_DOC)
  }

  async getExposureEquipmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EXPOSURE_EQUIPMENT_OPTIONS)
  }

  async getSuspectedExposureTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SUSPECTED_EXPOSURE_TYPE_OPTIONS)
  }

  async getExposedToOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EXPOSED_TO_OPTIONS)
  }

  async getExposureCrewOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EXPOSURE_CREW)
  }

  async getSuspectedExposureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SUSPECTED_EXPSOURE)
  }

  async getAirbagDeployedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRBAG_DEPLOYED_OPTIONS)
  }

  async getVehicleImpactSiteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VEHICLE_IMPACT_SITE_OPTIONS)
  }

  async getLocationOfPatientInVehicleOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LOCATION_OF_PATIENT_IN_VEHICLE_OPTIONS)
  }

  async getExtricationRequiredOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EXTRICATION_REQUIRED_OPTIONS)
  }

  async getEkgFilterFromTimeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EKG_IMPORT_FILTER_FROM_TIME_OPTIONS)
  }

  async getPulsaraDateRangeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PULSARA_DATE_RANGE_OPTIONS)
  }

  async getEkgMonitorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EKG_MONITOR_OPTIONS)
  }

  async getCountyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COUNTY_DOC)
  }

  async getSystemOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SYSTEM_DOC)
  }

  async getSymptomsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SYMPTOMS_DOC)
  }

  async getImpressionsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMPRESSIONS_DOC)
  }

  async getAnatomicLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ANATOMIC_LOCATION_DOC)
  }

  async getFinalPatientAcuityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FINAL_PATIENT_ACUITY_DOC)
  }

  async getConditionAtDestOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CONDITION_AT_DEST_DOC)
  }

  async getIsPatientPregnantOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IS_PATIENT_PREGNANT_OPTIONS)
  }

  async getNumberRangeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SELECTION_RANGE_OPTIONS)
  }

  async getBloodyShowOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BLOODY_SHOW_OPTIONS)
  }

  async getPrenatalCareOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PRENATAL_CARE_OPTIONS)
  }

  async getMembranesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEMBRANES_AMNIOTIC_FLUID_OPTIONS)
  }

  async getMaternalMedicationsAdministeredOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MATERNAL_MEDICATIONS_ADMINISTERED_OPTIONS)
  }

  async getBurnTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BURN_TYPE_OPTIONS)
  }

  async getAssessmentExamOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ASSESSMENT_EXAM_OPTIONS)
  }

  async getAssessmentNeuroExamOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ASSESSMENT_NEURO_OPTIONS)
  }

  async getAssessmentMentalExamOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ASSESSMENT_MENTAL_OPTIONS)
  }

  async getAssessmentDefaultOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ASSESSMENT_DEFAULT_OPTIONS)
  }

  async getAlsAssessmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ALS_ASSESSMENT_OPTIONS)
  }

  async getAssessmentNeuroOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.NEURO_OPTIONS)
  }

  async getAssessmentActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ACTION_OPTIONS)
  }

  async getSepsisIndicatorsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SEPSIS_INDICATORS)
  }

  async getCustomActionFieldsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CUSTOM_ACTION_FIELDS)
  }

  async getCustomActionFieldsAnswersOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CUSTOM_ACTION_FIELDS_ANSWERS)
  }

  async getAllPNNVOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ALL_PNNV_OPTIONS)
  }

  async getCommonAddressesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMMON_ADDRESSES_DOC)
  }

  async getOtherAgencyNameOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OTHER_AGENCY_NAME_OPTIONS)
  }

  async getOtherAgencyTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OTHER_AGENCY_TYPE_OPTIONS)
  }

  async getReasonsForFailureOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.REASONS_FOR_FAILURE_DOC)
  }

  async getStateRules(state: string | null): Promise<IClientDataDoc | undefined | null> {
    const STATE_DOC = this.STATE_RULES + state?.toLocaleLowerCase()
    return await this.getDocument(STATE_DOC)
  }

  async getServiceRules(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SERVICE_RULES)
  }

  async getStateCustomElements(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STATE_CUSTOM_ELEMENTS_DOC)
  }

  async getStateCustomElementConfigGroups(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STATE_CUSTOM_ELEMENT_CONFIG_GROUPS)
  }

  async getComplexRulesCount(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COMPLEX_RULES_COUNT)
  }

  async getSecurityQuestionAnswerOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SECURITY_QUESTION_ANSWER_OPTIONS)
  }

  async getServicesBillingOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SERVICES_BILLING)
  }

  async getClinicalIndicatorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CLINICAL_INDICATOR_OPTIONS)
  }

  async getTransfusionConsentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRANSFUSION_CONSENT_OPTIONS)
  }

  async getBloodProductOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BLOOD_PRODUCT_OPTIONS)
  }

  async getBloodProductRouteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BLOOD_PRODUCT_ROUTE_OPTIONS)
  }

  async getImpliedEmergentConsentReasonOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMPLIED_EMERGENT_CONSENT_REASON_OPTIONS)
  }

  async getVadTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_TYPE)
  }

  async getVadAlarmsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_ALARMS)
  }

  async getVadSiteAssessmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_SITE_ASSESSMENT)
  }

  async getVadCatheterSizeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_CATHETER_SIZE)
  }

  async getVadPlacementConfirmedByOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_PLACEMENT_CONFIRMED_BY)
  }

  async getVadInsertLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_INSERT_LOCATION)
  }

  async getVadMotorCurrentWaveformCharacteristicsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_MOTOR_CURRENT_WAVEFORM_CHARACTERISTICS)
  }

  async getVadPlacementSignalWaveformCharacteristicsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_PLACEMENT_SIGNAL_WAVE_FORM_CHARACTERISTICS)
  }

  async getVadPlacementLocationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_PLACEMENT_LOCATION)
  }

  async getVadPowerTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_POWER_TYPE)
  }

  async getVadBackupOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_BACKUP_OPTIONS)
  }

  async getVadBatteryStatusOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_BATTERY_STATUS)
  }

  async getVadFlowTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_FLOW_TYPE)
  }

  async getVadIndicationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_INDICATION)
  }

  async getVadMakeModelOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_MAKE_MODEL)
  }

  async getVadMakeModelImpellaOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.VAD_MAKE_MODEL_IMPELLA)
  }

  async getYesNoOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TB_UTIL_YES_NO)
  }

  async getCriticalCareSiteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CRITICAL_CARE_SITE_OPTIONS_DOC)
  }
  async getIabpAugmentationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IABP_AUGMENTATION_OPTIONS_DOC)
  }
  async getTaskOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TASK_OPTIONS_DOC)
  }
  async getIabpFrequencyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IABP_FREQUENCY_OPTIONS_DOC)
  }
  async getInsertionSiteOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INSERTION_SITE_OPTIONS_DOC)
  }
  async getTriggerUtilizedOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRIGGER_UTILIZED_OPTIONS_DOC)
  }
  async getCriticalCareActionOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CRITICAL_CARE_ACTION_OPTIONS_DOC)
  }
  async getSlowGasLeakOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SLOW_GAS_LEAK_OPTIONS_DOC)
  }
  async getAutoManualOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AUTO_MANUAL_OPTIONS_DOC)
  }

  async getTeamOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TEAM_OPTIONS_DOC)
  }

  async getTeamCareOnlyOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TEAM_CARE_ONLY_OPTIONS_DOC)
  }

  async getEquipmentOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EQUIPMENT_OPTIONS_DOC)
  }

  async getProviderRolesOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PROVIDER_ROLES_OPTIONS_DOC)
  }

  async getSctProcsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SCT_PROCS_OPTIONS_DOC)
  }

  async getSctMedsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SCT_MEDS_OPTIONS_DOC)
  }

  async getCustomFluidsOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.CUSTOM_FLUIDS_OPTIONS_DOC)
  }

  async getAdministeredByAnotherUnitOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ADMINISTERED_BY_OTHER_UNIT_OPTIONS_DOC)
  }

  async getAirwayPlacementTechniqueOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AIRWAY_PLACEMENT_TECHNIQUE_OPTIONS_DOC)
  }

  async getSpecialReportData(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SPECIAL_REPORT_DATA_DOC)
  }

  async getSpecialReportCategories(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SPECIAL_REPORT_CATEGORIES_DOC)
  }

  async getSpecialReportSubCategories(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SPECIAL_REPORT_SUB_CATEGORIES_DOC)
  }

  async getMedicalConsultFacilityOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.MEDICAL_CONSULT_FACILITY_OPTIONS_DOC)
  }
  async getFlightPlanOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.FLIGHT_PLAN_OPTIONS_DOC)
  }
}
